import {AddIcon, ArrowRightIcon, TrashIcon} from "../../kits/Icons/Icons";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Image from "../../common/Image";
import {pathMaker} from "../../../utilities/helperFunctions";
import {addCommas} from "@persian-tools/persian-tools";

import "./ShiftWork.scss"
import ColorSchema from "../../../assets/kits/colors";
import CustomButton from "../../kits/custom-button/CustomButton";
import colors from "../../../assets/kits/colors";
import React, {useState} from "react";
import {Form} from "react-bootstrap";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import TimePickerDrawer from "./TimePickerDrawer";
import SimpleSlider from "./SimpleSlider";


const titleShift = ["اول", "دوم", "سوم", "چهارم", "پنجم", "ششم", "هفتم", "هشتم", "نهم", "دهم"];

const itemDays = [
    {
        title: "همه روزهای هفته",
        id: 0
    },
    {
        title: "شنبه",
        id: 1
    },
    {
        title: "یکشنبه",
        id: 2
    },
    {
        title: "دوشنبه",
        id: 3
    },
    {
        title: "سه شنبه",
        id: 4
    },
    {
        title: "چهارشنبه",
        id: 5
    },
    {
        title: "پنجشنبه",
        id: 6
    },
    {
        title: "جمعه",
        id: 7
    },
]


const ShiftWork = () => {

    const [daySelect, setDaySelect] = useState([]);
    const [timePickerOpen, setTimePickerOpen] = useState(false);

    const shifts = [
        {title: "ساعت 06:30 تا 10:00"},
        {title: "ساعت 10:30 تا 12:00"},
        {title:"ساعت 12:30 تا 14:00"},
        {title: "ساعت 06:30 تا 10:00"},
        {title: "ساعت 10:30 تا 12:00"},
        {title:"ساعت 12:30 تا 14:00"},
    ]


    const getSelectedDays = () => {
        let out = "";

        if (daySelect.includes(0)) {
            return itemDays.filter(it => it.id == 0)[0].title
        } else {
            daySelect.map((day, index) => {
                out += itemDays.filter(it => it.id == day)[0].title
                if (index != (daySelect.length - 1)) {
                    out += ", "
                }
            })
            return out;
        }

    }

    return (
        <div className="position-relative h-100 overflow-hidden d-flex flex-column" >
            <TimePickerDrawer  open={timePickerOpen} setIsOpen={setTimePickerOpen} className="z-index-timepicker"/>

            <div className="d-flex flex-row pd-x-20 pd-t-12">
                <ArrowRightIcon width={24} height={24}/>
                <span className="title-h3-b mr-r-8">شیفت های کاری</span>
            </div>
            <div className="d-flex flex-column shift-work overflow-scroll pd-b-96 flex-grow-1 pd-t-12">
                    <Accordion defaultActiveKey="0" className="border-0 mr-t-14">
                        <Card className="rd-8 border-0 shadow-md ">
                            <Card.Header className="pd-x-16 pd-y-0  border-0 bg-white rd-8">
                                <Accordion.Header className="border-0" style={{color: "#000"}}>
                                    <div className="d-flex flex-column">
                                        <span className="txt-t1-m">تعیین روزهای کاری</span>
                                        <span className="txt-t2-r">
                                        {(daySelect.length == 0) ? "چه روزهایی فروشگاه باز است؟" : getSelectedDays()}
                                    </span>
                                    </div>
                                </Accordion.Header>
                            </Card.Header>
                            <Accordion.Body className="pd-x-16 pd-t-10 pd-b-0">
                                <div className="d-flex flex-column">
                                    {(itemDays.map((item, index) => (
                                        <div
                                            className={`form-group form-check p-0 ${(index != (itemDays.length - 1)) ? "mr-b-16" : "mr-0"}`}>
                                            <label
                                                className="form-check-label pd-y-0 pd-r-12 txt-t2-m ">{item.title}</label>

                                            <input
                                                type="checkbox"
                                                name={item.id}
                                                checked={(daySelect.filter(d => d == item.id).length > 0)}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        if (item.id == 0) {
                                                            let allSelect = [];
                                                            itemDays.map(it => allSelect.push(it.id));
                                                            setDaySelect(allSelect);
                                                        } else {
                                                            setDaySelect(select => [...select, item.id]);
                                                        }
                                                    } else {
                                                        if (item.id == 0) {
                                                            setDaySelect([]);
                                                        } else {
                                                            let newSelect = daySelect.filter(d => d != item.id);
                                                            setDaySelect((!newSelect.includes(0)) ? newSelect : newSelect.filter(d => d != 0))
                                                        }
                                                    }
                                                }}
                                                className="form-check-input shadow-none mx-0 my-auto"
                                                style={{width: "20px", height: "20px"}}
                                            />
                                        </div>
                                    )))}
                                </div>
                            </Accordion.Body>
                        </Card>
                    </Accordion>

                    <hr className="mr-y-16"/>

                    <div className="d-flex flex-column pd-x-16">
                        <span className="txt-t1-m">شیفت های کاری</span>
                        <span className="txt-t2-r">شیفت های کاری فروشگاه اگر ثابت است، در این قسمت وارد کنید.</span>
                    </div>
                    <div className="mr-y-4">

                        {(shifts.length > 0) && shifts.map((shift, index) => (
                            <>
                                {(index != 0) && <hr className="mr-x-16 mr-y-0"/>}

                                <div className={`pd-x-16 d-flex flex-row w-100 pd-y-12`} style={{color: "#000"}}>
                                    <div className="d-flex flex-column flex-grow-1">
                                        <span className="txt-t2-m">{shift.title}</span>
                                        <span className="desc-m">{`شیفت ${titleShift[index]}`}</span>
                                    </div>
                                    <TrashIcon
                                        containerIconClassName="my-auto"
                                        width={24}
                                        height={24}
                                        color="#292D32"
                                    />
                                </div>
                            </>
                        ))}
                    </div>

                    <div className={`w-100 pd-x-16 ${(shifts.length == 0) && "mr-t-8"}`}>
                        <CustomButton
                            className="pd-r-12 pd-l-16 pd-y-12 txt-t1-m"
                            style={{color: ColorSchema.foreground_background_he}}
                            onClick={() => setTimePickerOpen(true)}
                            icon={
                                <AddIcon
                                    width={24}
                                    height={24}
                                    color={ColorSchema.foreground_background_he}
                                />
                            }

                            iconPosition="right"
                            buttonStyle="text">
                            اضافه کردن شیفت کاری
                        </CustomButton>

                        <SimpleSlider
                            title="از ساعت"
                            containerClassName="mr-t-16"
                            onChange={(value) => {
                                console.log("startClock: ", value);
                            }}/>
                    </div>

            </div>

            <div style={{zIndex: "0"}} className="w-100 pd-16 position-absolute bottom-0 fixed-bottom bg-white">
                <CustomButton
                    size="large"
                    className="w-100"
                >
                    ثبت
                </CustomButton>
            </div>
        </div>

    );
};


export default ShiftWork;